<template>
  <div>
    <div class="column">
      <div style="padding: 0 0.75rem">
        <p v-html="$t('msg.probability_calculation')"></p>
        <p style="margin-top: 5px" v-html="$t('msg.probability_GL')"></p>

        <p style="margin-top: 1rem; font-weight: 600">
          {{$t('msg.probability_current_GL')}}
          <span style="color: #22c8b5">+14.56%</span>
        </p>
        <p style="font-weight: 600; margin-top: 5px">
          {{$t('msg.probability_current_wighted')}} <span>350 USDT</span>
        </p>
      </div>
      <div class="custom_table_filters column">
        <div class="component_normal_input_block dis_inb main_white_bg">
          <datepicker
            class="dis_inb"
            v-model="filterStartDate"
            name="uniquename"
            :placeholder="$t('msg.start_date')"
          ></datepicker>
        </div>
        <div class="component_normal_input_block dis_inb main_white_bg">
          <datepicker
            class="dis_inb"
            v-model="filterEndDate"
            name="uniquename"
            :placeholder="$t('msg.end_date')"
          ></datepicker>
        </div>

        <div class="component_normal_input_block dis_inb main_white_bg">
          <select v-model="statusFilter">
            <option value="all">{{ $tc("msg.all", 1) }}</option>
            <option value="cancelled">{{ $tc("msg.cancelled", 1) }}</option>
            <option value="done">{{ $tc("msg.status_done") }}</option>
            <option value="expired">{{ $tc("msg.status_expired") }}</option>
            <option value="failed">{{ $tc("msg.failed", 1) }}</option>
            <option value="new">{{ $tc("msg.new") }}</option>
            <option value="waiting">{{ $tc("msg.waiting", 1) }}</option>
          </select>
        </div>

        <button
          class="
            main_blue_lt_bg main_blue_lt_bg_hover
            component_main_button
            upper
          "
          @click="applyFilter()"
        >
          {{ $tc("msg.apply_filter", 1) }}
        </button>
        <button
          class="
            main_blue_lt_bg main_blue_lt_bg_hover
            component_main_button
            upper
          "
          @click="clearFilter()"
        >
          {{ $tc("msg.clear_filter", 1) }}
        </button>
      </div>
    </div>

    <div class="column tal_r">
      <input
        v-model="searchBox"
        class="custom_input_white"
        :placeholder="$t('msg.global_search')"
      />
    </div>
    <div class="column">
      <vue-good-table
        :columns="columns"
        :rows="withdrawsOnPage"
        :select-options="{ enabled: false }"
        :search-options="{
          enabled: true,
          searchFn: customSearch,
          externalQuery: searchBox,
        }"
        ref="historytable"
        :line-numbers="true"
        :sort-options="{
          enabled: true,
          initialSortBy: { field: 'createdAt', type: 'desc' },
        }"
        :pagination-options="{
          enabled: true,
          mode: 'records',
          perPage: '5',
          position: 'down',
          perPageDropdown: [10, 15, 20],
          dropdownAllowAll: false,
          nextLabel: 'next',
          prevLabel: 'prev',
          rowsPerPageLabel: 'per page',
          ofLabel: 'of',
          pageLabel: 'page', // for 'pages' mode
          allLabel: 'All',
        }"
      >
        <template slot="table-column" slot-scope="props">
          <!-- <span v-if="props.column.label == 'id'">{{ $t("msg.txid") }}</span> -->
          <span v-if="props.column.label == 'Redemption Date/Time'">
            Redemption Date/Time
          </span>
          <span v-if="props.column.label == 'Redemption Price'"
            >Redemption Price</span
          >
          <span v-if="props.column.label == 'Average Purchase Price'"
            >Average Purchase Price</span
          >
          <span v-if="props.column.label == 'G/L'">G/L</span>
          <span v-if="props.column.label == 'actions'">{{
            $t("msg.actions")
          }}</span>
        </template>

        <template slot="table-row" slot-scope="props">
          <!-- <span v-if="props.column.label == 'id'">
            <a
              v-if="props.formattedRow[props.column.field]"
              :title="$t('msg.details')"
              :href="`https://bscscan.com/tx/${
                props.formattedRow[props.column.field]
              }`"
              target="blank_"
              >{{ ajustTokenID(props.formattedRow[props.column.field]) }}</a
            >
          </span> -->
          <span v-if="props.column.field == 'Redemption Date/Time'">
            {{ formatDate(props.formattedRow[props.column.field]) }}
          </span>
          <span v-if="props.column.field == 'Redemption Price'">
            {{ formatDate(props.formattedRow[props.column.field]) }}
          </span>
          <span v-if="props.column.field == 'Average Purchase Price'">
            <span v-if="props.formattedRow[props.column.field] > 0">
              <span v-if="props.formattedRow[props.column.field]">{{
                props.formattedRow[props.column.field].toFixed(6)
              }}</span>
              {{ symbAjust(props.row.currency.symbol) }}
            </span>
            <span v-else>-</span>
          </span>
          <span v-if="props.column.field == 'G/L'">{{
            $t("msg.status_" + props.formattedRow[props.column.field])
          }}</span>
          <span v-if="props.column.field == 'actions'">{{
            props.formattedRow[props.column.field]
          }}</span>
        </template>

        <div slot="emptystate">
          <p class="tac">{{ $tc("msg.no_data_found", 1) }}</p>
        </div>
      </vue-good-table>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";

import spacetime from "spacetime";

export default {
  created() {
    this.getDeposits();
  },
  mounted() {},
  data: () => ({
    searchBox: "",
    statusFilter: "all",
    filterStartDate: "",
    filterEndDate: "",
    withdraws: [],
    withdrawsOnPage: [],
    columns: [
      {
        label: "Redemption Date/Time",
        field: "Redemption Date/Time",
      },
      {
        label: "Redemption Price",
        field: "Redemption Price",
      },
      {
        label: "Average Purchase Price",
        field: "Average Purchase Price",
        type: "number",
        filterable: true,
      },
      {
        label: "G/L",
        field: "G/L",
        filterable: true,
      },
      {
        label: "actions",
        field: "actions",
        filterable: false,
      },
    ],
  }),
  components: {
    Datepicker,
  },
  methods: {
    async getDeposits() {
      try {
        let resp = await this.$store.dispatch("getWithdraws");
        this.withdraws = this.sortByCreatedAt(resp.data);
        this.withdrawsOnPage = this.sortByCreatedAt(resp.data);
      } catch (e) {
        console.log(e);
      }
    },

    symbAjust(el) {
      if (el == "BLU") {
        return "BLUE";
      } else {
        return el;
      }
    },

    sortByCreatedAt(array) {
      array.sort((a, b) => {
        if (new Date(a.createdAt) > new Date(b.createdAt)) return 1;
        if (new Date(a.createdAt) < new Date(b.createdAt)) return -1;
        return 0;
      });

      var today = new Date();
      this.filterEndDate = today;
      this.filterStartDate = array[0].createdAt;
      return array;
    },

    applyFilter() {
      let startDateOnInput = this.filterStartDate;
      let endDateOnInput = this.filterEndDate;

      let date1 = new Date(startDateOnInput);
      let date2 = new Date(endDateOnInput);

      let startDate = `${date1.getFullYear()}-${
        date1.getMonth() + 1 < 10
          ? "0" + (date1.getMonth() + 1)
          : date1.getMonth() + 1
      }-${
        date1.getDate() < 10 ? "0" + date1.getDate() : date1.getDate()
      }T00:00:00.000Z`;

      let endDate = `${date2.getFullYear()}-${
        date2.getMonth() + 1 < 10
          ? "0" + (date2.getMonth() + 1)
          : date2.getMonth() + 1
      }-${
        date2.getDate() < 10 ? "0" + date2.getDate() : date2.getDate()
      }T23:59:999Z`;

      this.filterRowByDate(startDate, endDate);
    },

    filterRowByDate(startDate, endDate) {
      this.withdrawsOnPage = this.withdraws;

      this.withdrawsOnPage = this.withdrawsOnPage.filter((item) => {
        return item.createdAt > startDate && item.createdAt < endDate;
      });

      if (this.statusFilter != "all") {
        this.withdrawsOnPage = this.withdrawsOnPage.filter((item) => {
          return item.status == this.statusFilter;
        });
      }
    },

    clearFilter() {
      let vm = this;
      this.withdrawsOnPage = this.withdraws;
      this.statusFilter = "all";
    },

    customSearch(row, col, cellValue, searchTerm) {
      let vm = this;
      if (String(cellValue).indexOf("" + searchTerm) >= 0) {
        vm.csv_data = vm.rowsOnPage;

        return cellValue;
      }
    },

    ajustTokenID(tokenID) {
      let str = tokenID;
      let res = str.substring(0, 15);

      return res + "... [+]";
    },

    formatDate(value) {
      return spacetime(value).format("dd/MM/yyyy HH:mm:SS");
    },
  },
  computed: {},
  watch: {},
};
</script>



// WEBPACK FOOTER //
// src/components/private/transactions/TransactionTableProbability.vue